import { Suspense } from 'react'
import { PageTransition } from '@/components/common/PageTransition'
import { PageLoader } from '@/pages/PageLoader'

export const AuthLayout = () => {
  return (
    <div className="min-h-screen">
      <Suspense fallback={<PageLoader />}>
        <PageTransition />
      </Suspense>
    </div>
  )
}
